import * as React from "react";
import { SVGProps } from "react";
export function MemberTypeProfessionalIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={29}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={1.083}
        y={0.583}
        width={26.833}
        height={26.833}
        rx={13.417}
        fill="#21597A"
      />
      <rect
        x={1.083}
        y={0.583}
        width={26.833}
        height={26.833}
        rx={13.417}
        stroke="#21597A"
        strokeWidth={1.167}
      />
      <path
        d="M8.577 9.692h11.846s1.077 0 1.077 1.077v9.154S21.5 21 20.423 21H8.577S7.5 21 7.5 19.923v-9.154s0-1.077 1.077-1.077Z"
        stroke="#fff"
        strokeWidth={1.167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m7.5 14.312 6.39 1.89c.398.117.822.117 1.22 0l6.39-1.89M12.156 9.692V8.077c0-.595.482-1.077 1.077-1.077h2.523c.595 0 1.077.482 1.077 1.077v1.615"
        stroke="#fff"
        strokeWidth={1.167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
